/**
 * houseFacets — which facet tokens a house's wall has. `facetShares.json` (written by the wall ingest,
 * `scripts/wall/facets/shares.ts`) lists the share of the house's packs that carry each token, so its keys are the
 * tokens the house's tiles can carry; core reads the house through it and imports nothing from a product. Pure.
 */
import facetShares from './facetShares.json'

/** The share of each house's packs that carry each facet token. */
export const FACET_SHARES: Record<string, Record<string, number>> = facetShares

/** Whether `token` is a facet token of `house`: its key and its value are the house's. */
export function isHouseFacet(house: string, token: string): boolean {
    return FACET_SHARES[house]?.[token] !== undefined
}
